export const y2WellSections = (range, proportion, md, discountRange0, numberOfSections, i): number =>
    range.length > 0 ? proportion * md - discountRange0 : (480 / numberOfSections) * (i + 1)

export const y2WellSectionsWithBegin = (range, proportion, md, discountRange0, numberOfSections, i): number =>
    range.length > 0 ? proportion * md - discountRange0 - 5 : (480 / numberOfSections) * (i + 1)

export const wellSectionWidth = (numberOfSections: number, i: number, beforeBegin): string =>
    20 + (numberOfSections - i) * 16 + (beforeBegin ? 1 : 0) + 'px'

export const pointsCasing = (section, proportion, i, discountRange0, range, numberOfSections, whichCasing): string => {
    let xPosition =
        whichCasing === 'right' ? 12.5 + numberOfSections * 8 + (numberOfSections - i) * 8 : (i + 1) * 8 - 0.5
    let yPositionBegin = proportion * section.casing_begin - discountRange0
    let xPositionBegin = range.length > 0 ? (whichCasing === 'right' ? 5.8 : -5.8) : 0
    return (
        (section.casing_begin ? xPosition + xPositionBegin + ',' + yPositionBegin + ' ' : '') +
        xPosition +
        ',' +
        (section.casing_begin ? yPositionBegin : '0') +
        ' ' +
        xPosition +
        ',' +
        (range.length > 0
            ? proportion * section.md_casing_shoe - 2 - discountRange0
            : (480 / numberOfSections) * (i + 1) - 2)
    )
}

export const positionCasingShoe = (
    position,
    proportion,
    range,
    discountRange0,
    numberOfSections,
    i,
    wichShoe
): string =>
    'translate(' +
    (wichShoe === 'right' ? 12 + numberOfSections * 8 + (numberOfSections - i) * 8 : i * 8) +
    'px, ' +
    (range.length > 0 ? proportion * position - 10 - discountRange0 : (480 / numberOfSections) * (i + 1) - 10) +
    'px)'

export const positionX = numberOfSections => (numberOfSections === 0 ? 30 : 10 + numberOfSections * 8)

export const positionXForBoxes = numberOfSections => (numberOfSections === 0 ? 47 : 31 + numberOfSections * 16)

export const safepositionXForBoxes = (numberOfSections, width, lithology, translated) => (
    ( ((positionXForBoxes(numberOfSections) + 84 + Number(translated) + (lithology ? 26 : 0))  <= width ) || width == null)? positionXForBoxes(numberOfSections) :
        (width - 84 - (lithology ? 26 : 0) - Number(translated))
)

export const positionXForLines = numberOfSections => (numberOfSections === 0 ? 36 : 16 + numberOfSections * 5)
export const positionXForLinesRange = numberOfSections => (numberOfSections === 0 ? 36 : 16 + numberOfSections * 5)

export const sectionValueBoxConnectorPoints = (
    numberOfSections,
    i,
    section,
    proportion,
    discountRange0,
    range = [],
    height = 569, width, lithology, translated
): string =>
    (range.length > 0 ? positionXForLinesRange(numberOfSections) : positionXForLines(numberOfSections)) +
    (numberOfSections - i) * 5 +
    ',' +
    (range.length > 0
        ? proportion * section.md_casing_shoe - discountRange0
        : // : ((height * 0.84 * 0.8) / numberOfSections) * (i + 1) - 2) +
          (480 / numberOfSections) * (i + 1) - 2) +
    ' ' +
    safepositionXForBoxes(numberOfSections, width, lithology, translated) +
    ',' +
    (range.length > 0 ? ((height * 0.8) / numberOfSections) * (i + 1) - 2 + 22 : (569 / numberOfSections) * (i + 1) - 2)

export const bitDepthvalueBoxConnectorPoints = (
    numberOfSections,
    i,
    section,
    proportion,
    bitDepth,
    discountRange0,
    range = [],
    height = 569, width, lithology, translated
): string =>
    (range.length > 0 ? positionXForLinesRange(numberOfSections) : positionXForLines(numberOfSections)) +
    (numberOfSections - i) * 3 +
    ',' +
    (range.length > 0
        ? proportion * section.md_casing_shoe - discountRange0
        : // : ((height * 0.84 * 0.8) / numberOfSections) * (i + 1) - 2) +
          (480 / numberOfSections) * (i + 1) - 2) +
    ' ' +
    safepositionXForBoxes(numberOfSections, width, lithology, translated) +
    ',' +
    (range.length > 0 ? ((height * 0.8) / numberOfSections) * (i + 1) - 2 + 22 : (569 / numberOfSections) * (i + 1) - 2)

export const holeDepthValueBoxConnectorPoints = (
    numberOfSections,
    range,
    proportion,
    discountRange0,
    holeDepth, width, lithology, translated
): string =>
    (range.length > 0 ? positionXForLinesRange(numberOfSections) : positionXForLines(numberOfSections)) +
    ',' +
    (range.length > 0 ? proportion * holeDepth - discountRange0 + '' : '613') +
    ' ' +
    (36 + numberOfSections * 8) +
    ',575 ' +
    safepositionXForBoxes(numberOfSections, width, lithology, translated) +
    ',575 '

export const defaultState: Partial<{ drillStringVelocity?: number; canRender: boolean } & SchematicValues> = {
    casingShoe: {},
    drillStringVelocity: null,
    holeDepth: null,
    bitDepth: null,
    prevBitDepth: null,
    uom: '',
    uomVelocity: '',
    sections: [],
    lithology: [],
    schematicType: 'surgenswab',
    range: [],
    canRender: false,
    heightOfOGMCartesian: false,
    allowZoom: false,
    showDrillBit: true,
    hideHoleDepth: false,
    paddingTop: 0,
    paddingBottom: 0,
    bottomComponent: 'drillBit'
}

export const lithologyPatterns: Array<string> = [
    '_Water',
    'OLEO',
    'MST',
    'MUD',
    'PAC',
    'LDA',
    'AGV',
    'ADT',
    'AND',
    'ARS',
    'ARE',
    'ARN',
    'ARL',
    'ARB',
    'ARC',
    'ARO',
    'ARF',
    'ART',
    'ARG',
    'AGT',
    'AGN',
    'AGL',
    'AGC',
    'AGS',
    'AGB',
    'BAF',
    'BAS',
    'BIN',
    'BLT',
    'BOU',
    'BDA',
    'BDL',
    'BRC',
    'BRR',
    'BRV',
    'CRE',
    'CAL',
    'CLC',
    'CLU',
    'CRU',
    'CSI',
    'CRN',
    'CRV',
    'CHT',
    'CIM',
    'CZV',
    'CGL',
    'COQ',
    'DCT',
    'DIA',
    'DMT',
    'DIO',
    'DOL',
    'FNG',
    'FLT',
    'FLO',
    'FLH',
    'FLS',
    'FNT',
    'PHO',
    'FRA',
    'GRO',
    'GIP',
    'GNA',
    'GRS',
    'GRN',
    'GRD',
    'HAL',
    'HIC',
    'INI',
    'IGB',
    'LPL',
    'LMA',
    'LNT',
    'MRG',
    'MRM',
    'MRD',
    'MAR',
    'MNI',
    'MSD',
    'MSI',
    'MDS',
    'OCG',
    'PKS',
    'PNI',
    'QZT',
    'RLT',
    'MAF',
    'ULT',
    'VCL',
    'RDS',
    'SNI',
    'SID',
    'SNT',
    'SLX',
    'SLT',
    'SLV',
    'TES',
    'TQD',
    'TIL',
    'TOB',
    'TON',
    'TOL',
    'TOS',
    'TQT',
    'TUF',
    'ULB',
    'VNI',
    'WKS',
    'XST',
    'AND_TQD_CRN',
    'HAL_IGN',
    'OTH_V',
    'OTH_NR'
]

const sizeValues = (width, sm, md, lg) => {}
